var scope_0 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/06791c142a656cd916791e599a4f859f.js').default;

var scope_1 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2327db6d2a1448c2f962638d07e8408e.js').default;

var scope_2 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2da2afff3c47d188a2ce76c2da60cfa6.js').default;

var scope_3 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5fe5c8ba4c502c204d5945bbfa98a1a3.js').default;

var scope_4 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/72cffdcc46ec901a36c67ea45fe58c64.js').default;

var scope_5 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7ae65c61a5bf13de7f9f2d712501ba26.js').default;

var scope_6 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9139201f7ebd084a68d4adacc3fabe65.js').default;

var scope_7 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9f0eea182260863d18792eb2ee81e619.js').default;

var scope_8 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c513462ba6406b97a5524ac8863e7c7f.js').default;

var scope_9 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d529277a96465b9d77ac76deca863de5.js').default;

var scope_10 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dbc87edae4265110130f4aa120ea1830.js').default;

var scope_11 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e361301cdb0fafa5bf4a1bd83cb49801.js').default;

var scope_12 = require('/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}